import {getheaders} from "./authService";

export async function getAllProperties(startDate, endDate) {

    let requestOptions = {
        method: 'GET', headers: getheaders(), redirect: 'follow'
    };
    return fetch("/goapi/properties", requestOptions)
}

export async function getAllPropertiesWithDurations() {
    return fetch("/goapi/properties?include=durations", {
        method: 'GET', headers: getheaders(), redirect: 'follow'
    });
}

export async function getPropertyDurations(propertyId) {
    return fetch(`/api/properties/${propertyId}/durations`, {
        method: 'GET', headers: getheaders(), redirect: 'follow'
    });
}

export async function updatePropertyDurations(propertyId, durations) {
    return fetch(`/api/properties/${propertyId}/durations`, {
        method: 'PUT',
        headers: getheaders(),
        redirect: 'follow',
        body: JSON.stringify({durations})
    });
}

export async function getPropertyById(propertyId) {
    let requestOptions = {
        method: 'GET', headers: getheaders(), redirect: 'follow'
    };
    return fetch(`/goapi/properties/${propertyId}`, requestOptions)
}

export async function updateProperty(payload) {
    return fetch('/api/properties', {
        method: 'PUT', headers: getheaders(), redirect: 'follow', body: JSON.stringify(payload)
    });
}

export async function getPropertyJobTypes() {
    return fetch('/api/jobtypes', {headers: getheaders()});
}

export async function getPropertyConsumableTypes() {
    return fetch('/api/consumabletypes', {headers: getheaders()});
}

export async function getPropertyGuestKey(propertyId) {
    return fetch(`/api/properties/${propertyId}/guest-key`, {headers: getheaders(), cache: 'no-store'});
}

export async function updatePropertyGuestKey(propertyId, settings) {
    return fetch(`/api/properties/${propertyId}/guest-key`, {
        method: 'PUT', headers: getheaders(), body: JSON.stringify(settings),
    });
}

export async function getPropertyLockerRotations(propertyId) {
    return fetch(`/api/properties/${propertyId}/guest-key/locker-rotations`, {headers: getheaders(), cache: 'no-store'});
}

export async function updatePropertyLockerTarget(propertyId, target) {
    return fetch(`/api/properties/${propertyId}/guest-key/locker-rotations/target`, {
        method: 'PUT', headers: getheaders(), body: JSON.stringify(target),
    });
}

export async function cancelPropertyLockerRotation(propertyId, checklistId, version) {
    return fetch(`/api/properties/${propertyId}/guest-key/locker-rotations/${checklistId}?version=${encodeURIComponent(version)}`, {
        method: 'DELETE', headers: getheaders(),
    });
}

export async function createOrUpdatePropertyInstruction(payload, type) {
    let httpMethod = "POST";
    if (payload.id) {
        httpMethod = "PUT";
    }
    let requestOptions = {
        method: httpMethod, headers: getheaders(), redirect: 'follow', body: JSON.stringify(payload)
    };
    return fetch("/api/instructions/" + type, requestOptions)
}

export async function getPropertyInstruction(propertyId, type) {
    let requestOptions = {
        method: 'GET', headers: getheaders(), redirect: 'follow'
    };
    return fetch("/api/instructions/" + type + "/" + propertyId, requestOptions)
}

export async function getPropertyIssue(propertyId) {
    let requestOptions = {
        method: 'GET', headers: getheaders(), redirect: 'follow'
    };
    return fetch("/api/issues/" + propertyId, requestOptions)
}

export async function createOrUpdatePropertyIssue(payload) {
    let httpMethod = "POST";
    if (payload.id) {
        httpMethod = "PUT";
    }
    let requestOptions = {
        method: httpMethod, headers: getheaders(), redirect: 'follow', body: JSON.stringify(payload)
    };
    return fetch("/api/issues", requestOptions)
}

export async function deletePropertyIssue(issueId) {
    let requestOptions = {
        method: 'DELETE', headers: getheaders(), redirect: 'follow'
    };
    return fetch("/api/issues/" + issueId, requestOptions)
}

export async function resolveOrReopenIssue(payload) {
    let httpMethod = "PUT";
    let action = payload.action;

    console.log(action + " issue" + payload.cos_job_id)
    let requestOptions = {
        method: httpMethod, headers: getheaders(), redirect: 'follow', body: JSON.stringify(payload)
    };
    return fetch(`/api/issues/${action}`, requestOptions)
}
